export default __webpack_public_path__ + "static/media/logo-eco-chat.6464e07d.svg";